import { reactive } from 'vue';

export const oauthLoadingState = reactive<{
  active: boolean;
  error: string | null;
}>({ active: false, error: null });
